(() => {
  function init(root = document) {
    root.querySelectorAll('[data-ez-product]').forEach(card => {
      if (card.dataset.ready) return;
      card.dataset.ready = 'true';
      const select = card.querySelector('[data-ez-variant]');
      if (!select) return;
      const image = card.querySelector('.ez-card__photo');
      const full = card.querySelector('[data-ez-fullimage]');
      const thumbs = card.querySelectorAll('[data-ez-thumb]');
      function showImage(src) {
        if (!src || !image) return;
        image.removeAttribute('srcset');
        image.src = src;
        if (full) full.href = src;
      }
      thumbs.forEach(thumb => thumb.addEventListener('click', () => {
        showImage(thumb.dataset.ezThumb);
        thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === thumb)));
      }));
      const choices = card.querySelector('.ez-color-choices');
      if (choices) { choices.hidden = false; select.classList.add('ez-select-enhanced'); }
      card.querySelectorAll('[data-ez-choice]').forEach(choice => choice.addEventListener('click', () => {
        select.value = choice.dataset.ezChoice;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        card.querySelector('[data-ez-price]').textContent = option.dataset.price;
        showImage(option.dataset.image);
        if (image) image.alt = (card.querySelector('h1, h3')?.textContent.trim() || '') + ' – ' + option.textContent.trim();
        card.querySelectorAll('[data-ez-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(choice.dataset.ezChoice === select.value)));
        thumbs.forEach(thumb => {
          const src = thumb.dataset.ezView === 'original' ? option.dataset.original : option.dataset.image;
          if (src) { thumb.dataset.ezThumb = src; const preview = thumb.querySelector('img'); preview.removeAttribute('srcset'); preview.src = src.replace(/width=\d+/, 'width=140'); }
          thumb.setAttribute('aria-pressed', String(thumb.dataset.ezView === 'studio'));
        });
        const button = card.querySelector('[data-ez-add]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.sold : button.dataset.label;
        if (card.hasAttribute('data-ez-product-page')) {
          const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState(history.state, '', url);
          image.alt = card.querySelector('h1').textContent.trim() + ' – ' + option.textContent.trim();
        }
      });
    });
    root.querySelectorAll('[data-ez-video]').forEach(video => {
      if (video.dataset.ready) return;
      video.dataset.ready = 'true';
      const button = video.closest('.ez-hero').querySelector('[data-ez-toggle]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let manualPause = reduced.matches || navigator.connection?.saveData === true;
      let visible = false;
      const start = () => {
        if (manualPause || !visible || document.hidden) return;
        if (!video.src) video.src = video.dataset.src;
        video.play().catch(() => { video.classList.remove('is-playing'); });
      };
      video.addEventListener('playing', () => { video.classList.add('is-playing'); button.classList.remove('is-paused'); button.setAttribute('aria-label', button.dataset.pause); });
      video.addEventListener('pause', () => { button.classList.add('is-paused'); button.setAttribute('aria-label', button.dataset.play); });
      video.addEventListener('error', () => video.classList.remove('is-playing'));
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (visible) start(); else video.pause(); }, { threshold: .1 });
      observer.observe(video);
      button.addEventListener('click', () => { manualPause = !video.paused; if (manualPause) video.pause(); else start(); });
      document.addEventListener('visibilitychange', () => document.hidden ? video.pause() : start());
      reduced.addEventListener('change', () => { manualPause = reduced.matches; if (manualPause) video.pause(); else start(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
